"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _FissionTablePane = _interopRequireDefault(require("./components/FissionTablePane.vue"));
var _FissionCreatePane = _interopRequireDefault(require("./components/FissionCreatePane.vue"));
var _FissionUpdatePane = _interopRequireDefault(require("./components/FissionUpdatePane.vue"));
var _FissionStatisticsPane = _interopRequireDefault(require("./components/FissionStatisticsPane.vue"));
var _FissionScalperWhitelistPane = _interopRequireDefault(require("./components/FissionScalperWhitelistPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FissionIndex',
  components: {
    FissionTablePane: _FissionTablePane.default,
    FissionCreatePane: _FissionCreatePane.default,
    FissionUpdatePane: _FissionUpdatePane.default,
    FissionStatisticsPane: _FissionStatisticsPane.default,
    FissionScalperWhitelistPane: _FissionScalperWhitelistPane.default
  },
  props: {},
  data: function data() {
    return {
      activeName: 'list',
      fissionId: '',
      fissionActivityName: ''
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    handleEdit: function handleEdit(id) {
      this.activeName = 'update';
      this.fissionId = id;
    },
    handleToCreate: function handleToCreate() {
      this.fissionId = '';
      this.activeName = 'create';
    },
    handleToTable: function handleToTable() {
      this.fissionId = '';
      this.activeName = 'list';
    },
    handleStatistics: function handleStatistics(id, title) {
      this.activeName = 'statistics';
      this.fissionId = id;
      this.fissionActivityName = title;
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'list') {
        this.fissionId = '';
        this.fissionActivityName = '';
      }
    },
    handleCopyToCreate: function handleCopyToCreate(id) {
      this.activeName = 'create';
      this.fissionId = id;
    }
  }
};